import "../Styles/Pages.css";
import "../Styles/PrivacyPolicy.css";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Return from "../Components/Return";
import OrnamentalDivider from "../Components/OrnamentalDivider";

const LAST_UPDATED = "24 May 2026";

export default function PrivacyPolicy() {
  return (
    <div className="page_content">
      <Header />

      <section className="privacy" aria-labelledby="privacy-heading">
        <h1 id="privacy-heading">Privacy Policy</h1>
        <OrnamentalDivider />

        <p className="privacy__updated">Last updated: {LAST_UPDATED}</p>

        <p>
          This page explains how <strong>The Old House Restaurant</strong> in
          Afantou, Rhodes (&ldquo;we&rdquo;, &ldquo;us&rdquo;) handles personal
          information when you use our website at{" "}
          <a href="https://oldhouse.gr">oldhouse.gr</a>. We keep things simple:
          we only collect what we need to take your table reservation, and we do
          not sell your data or use it for advertising.
        </p>

        <h2>Who is responsible for your data</h2>
        <p>
          The Old House Restaurant is the data controller. If you have any
          question about this policy or your information, contact us by email at{" "}
          <a href="mailto:info@oldhouse.gr">info@oldhouse.gr</a> or by post at
          Afantou village, 85103, Rhodes, Greece.
        </p>

        <h2>What we collect and why</h2>
        <p>
          When you submit a reservation request through the booking form (or our
          chat assistant), we collect the details you provide:
        </p>
        <ul>
          <li>your name;</li>
          <li>your email address;</li>
          <li>the number of guests; and</li>
          <li>the date and time you would like to visit.</li>
        </ul>
        <p>
          We use this information solely to receive your request, contact you to
          confirm or arrange your reservation, and keep a record of the booking.
          The legal basis is that processing is necessary to take steps at your
          request before providing our service to you (and, where relevant, your
          consent in submitting the form).
        </p>

        <h2>Who processes the data for us</h2>
        <p>
          Our website and reservations run on <strong>Google Firebase</strong>{" "}
          (Cloud Firestore and hosting), and confirmation emails are sent through
          a Firebase email service. Google acts as our processor and stores the
          data on its infrastructure, which may involve transfer to or processing
          in countries outside the European Economic Area under the safeguards
          Google provides in its data-processing terms. We do not share your
          information with anyone else, except where we are required to by law.
        </p>

        <h2>Cookies and third-party content</h2>
        <p>
          We do <strong>not</strong> use analytics, advertising, or tracking
          cookies on this website.
        </p>
        <p>
          Our typography uses <strong>Google Fonts</strong>. When a page loads,
          your browser fetches these fonts from Google, which means Google
          receives your IP address; no cookies are set by this.
        </p>
        <p>
          The <strong>Google Map</strong> on the &ldquo;Find Us&rdquo; page does{" "}
          <strong>not</strong> load automatically. It appears only after you
          choose to load it by clicking. If you do, Google may set its own
          cookies and receive your IP address at that point.
        </p>
        <p>
          A small amount of technical storage is used only when restaurant staff
          sign in to the private admin area; this is necessary for that login and
          is not used to track visitors.
        </p>

        <h2>How long we keep it</h2>
        <p>
          We keep reservation requests only for as long as we need them to manage
          your booking and our day-to-day operations, and then delete them. You
          can ask us to delete your information sooner at any time.
        </p>

        <h2>Your rights</h2>
        <p>
          Under the General Data Protection Regulation (GDPR) and Greek data
          protection law, you have the right to:
        </p>
        <ul>
          <li>access the personal data we hold about you;</li>
          <li>have inaccurate data corrected;</li>
          <li>have your data erased;</li>
          <li>restrict or object to how we use it;</li>
          <li>receive a copy of your data in a portable format; and</li>
          <li>withdraw any consent you have given.</li>
        </ul>
        <p>
          To exercise any of these rights, email us at{" "}
          <a href="mailto:info@oldhouse.gr">info@oldhouse.gr</a>. If you believe
          we have not handled your data properly, you may lodge a complaint with
          the Hellenic Data Protection Authority (Αρχή Προστασίας Δεδομένων
          Προσωπικού Χαρακτήρα) at{" "}
          <a
            href="https://www.dpa.gr"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.dpa.gr
          </a>
          .
        </p>

        <h2>Children</h2>
        <p>
          This website is intended for a general audience and is not directed at
          children. We do not knowingly collect personal data from children.
        </p>

        <h2>Changes to this policy</h2>
        <p>
          We may update this policy from time to time. When we do, we will revise
          the &ldquo;Last updated&rdquo; date at the top of this page.
        </p>
      </section>

      <Return />
      <Footer />
    </div>
  );
}
